// import React, { useState } from "react";
// import { FaTimes } from "react-icons/fa"; // Import cross icon
// import { useDispatch } from 'react-redux';
// import { setShippingAddress ,addSavedAddress, setBillingAddress} from '../../store/addressSlice';

// const AddressPopup = ({ onClose,shippingAddress }) => {
//   const dispatch = useDispatch();
//   // Initialize the address state
//   // const [address, setAddress] = useState({
//   //   name: '',
//   //   lastName: '',
//   //   email: '',
//   //   phone: '',
//   //   saveAddressAs: '',
//   //   addressLine1: '',
//   //   addressLine2: '',
//   //   city: '',
//   //   state: '',
//   //   postalCode: '',
//   //   country: ''
//   // });
// const [address, setAddress] = useState({
//     firstName: shippingAddress?.firstName || "",
//     lastName: shippingAddress?.lastName|| "",
//     email: shippingAddress?.email || "",
//     phone: shippingAddress?.phone || "",
//     address: shippingAddress?.address|| "",
//   });
  

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setAddress({ ...address, [name]: value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault(); // Prevent the default form submission behavior
//     // Dispatch the action to store the address in Redux
//     dispatch(setShippingAddress(address));
//     dispatch(setBillingAddress(address));
//     dispatch(addSavedAddress(address));
//     // dispatch(setShippingAddress(formFields));

//     // // Save address as the user's default address
//     // dispatch(addSavedAddress({ ...formFields, saveAddressAs: "Home" }));


//     onClose(); // Close the popup after saving the address
//   };
 
//   return (
//     <div className="fixed inset-0  flex items-center justify-center z-30 overflow-y-scroll">
//       <div className="bg-tertiary p-11 md:p-6 rounded md:w-[60%] relative top-24 lg:top-7">
//         <div className="flex justify-between items-center mb-4">
//           <h2 className="text-lg font-semibold text-center w-full">Add Address</h2>
//           <FaTimes
//             onClick={onClose}
//             className="text-xl cursor-pointer"
//           />
//         </div>
//         <hr className="mb-4" />
//         <form onSubmit={handleSubmit} className="grid grid-cols-1 lg:grid-cols-2 gap-4">
//           {/* Form Fields */}
//           {[{
//             label: "NAME", name: "firstName", type: "text", value: address.name,
//           }, {
//             label: "LAST NAME", name: "lastName", type: "text", value: address.lastName,
//           }, {
//             label: "E-MAIL", name: "email", type: "email", value: address.email,
//           }, {
//             label: "PHONE", name: "phone", type: "tel", value: address.phone,
//           }, {
//             label: "SAVE ADDRESS AS", name: "saveAddressAs", type: "text", value: address.saveAddressAs,
//           }, {
//             label: "HOUSE/FLAT/BLOCK NUMBER", name: "houseNumber", type: "text", value: address.houseNumber,
//           }, {
//             label: "AREA / BUILDING NAME", name: "area", type: "text", value: address.area,
//           }, {
//             label: "CITY", name: "city", type: "text", value: address.city,
//           }, {
//             label: "STATE", name: "state", type: "text", value: address.state,
//           }, {
//             label: "PINCODE", name: "pincode", type: "text", value: address.pincode,
//           }, {
//             label: "COUNTRY", name: "country", type: "text", value: address.country,
//           }].map((field, index) => (
//             <div key={index} className="-my-1">
//               <input
//                 id={field.name}
//                 name={field.name}
//                 type={field.type}
//                 value={field.value} // Use dynamic value binding
//                 onChange={handleChange}
//                 required
//                 className="w-full px-4 py-3 border-2 rounded-md bg-tertiary text-primary1 text-xs font-poppins focus:outline-none focus:ring-2 focus:ring-primary1 focus:border-tertiary"
//                 placeholder=" "
//               />
//               <label
//                 htmlFor={field.name}
//                 className="relative left-3 px-2 bg-tertiary text-primary1 font-outfit text-sm font-medium pointer-events-none transform -translate-y-4 scale-75 bottom-[80%] z-10 origin-[0]"
//               >
//                 {field.label}
//               </label>
//             </div>
//           ))}

//           {/* Buttons in the same row */}
//           <div className="lg:col-span-2 lg:flex justify-center gap-4 -mt-2">
//             <button
//               type="submit"
//               className="w-full py-2 bg-hcolor text-tertiary hover:border-2 hover:text-hcolor hover:bg-tertiary transition"
//             >
//               UPDATE
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default AddressPopup;

// import React, { useState } from "react";
// import { FaTimes } from "react-icons/fa";
// import { useDispatch } from "react-redux";
// import { addNewAddress } from "../../Providers/addressProvider";

// const AddressPopup = ({ onClose }) => {
//   const dispatch = useDispatch();

//   // Initialize state with default values
//   const [address, setAddress] = useState({
//     user_id: localStorage.getItem("user_id") || "",
//     first_name: "",
//     last_name: "",
//     mobile_number: "",
//     email_id: "",
//     addressType: "Home",
//     main_street: "",
//     city: "",
//     state: "",
//     postal_code: "",
//     country: "",
//     landmark: "",
//     isDefault: false,
//   });

//   // Handle form field changes
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setAddress({ ...address, [name]: value });
//   };

//   // Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       const resultAction = await dispatch(addNewAddress(address));

//       if (addNewAddress.fulfilled.match(resultAction)) {
//         console.log("Address added successfully:", resultAction.payload);
//       } else {
//         console.error("Failed to add address:", resultAction.payload);
//       }

//       onClose(); // Close popup after saving
//     } catch (error) {
//       console.error("Error adding address:", error);
//     }
//   };

//   return (
//     <div className="fixed inset-0 flex items-center justify-center z-30 overflow-y-scroll">
//       <div className="bg-tertiary p-11 md:p-6 rounded md:w-[60%] relative top-24 lg:top-7">
//         <div className="flex justify-between items-center mb-4">
//           <h2 className="text-lg font-semibold text-center w-full">Add New Address</h2>
//           <FaTimes onClick={onClose} className="text-xl cursor-pointer" />
//         </div>
//         <hr className="mb-4" />
//         <form onSubmit={handleSubmit} className="grid grid-cols-1 lg:grid-cols-2 gap-4">
//           {/* Input Fields */}
//           {[
//             { label: "Name", name: "first_name", type: "text" },
//             { label: "Last Name", name: "last_name", type: "text" },
//             { label: "Email", name: "email_id", type: "email" },
//             { label: "Phone", name: "mobile_number", type: "tel" },
//           ].map((field, index) => (
//             <div key={index} className="-my-1">
//               <input
//                 id={field.name}
//                 name={field.name}
//                 type={field.type}
//                 value={address[field.name] || ""}
//                 onChange={handleChange}
//                 required
//                 className="w-full px-4 py-3 border-2 rounded-md bg-tertiary text-primary1 text-xs font-poppins focus:outline-none focus:ring-2 focus:ring-primary1 focus:border-tertiary"
//                 placeholder={field.label}
//               />
//             </div>
//           ))}

//           {/* Save Address As Dropdown */}
//           <div className="lg:col-span-1 gap-4">
//             <div className="-my-1 relative">
//               <select
//                 id="addressType"
//                 name="addressType"
//                 value={address.addressType}
//                 onChange={handleChange}
//                 required
//                 className="w-full px-4 py-3 border-2 rounded-md bg-tertiary text-primary1 text-xs font-poppins focus:outline-none focus:ring-2 focus:ring-primary1 focus:border-tertiary appearance-none"
//               >
//                 <option value="Home">Home</option>
//                 <option value="Work">Work</option>
//                 <option value="Other">Other</option>
//               </select>
//             </div>
//           </div>

//           {/* Other Address Type Input Field */}
//           {address.addressType === "Other" && (
//             <div className="-my-1 mb-4 relative">
//               <input
//                 type="text"
//                 name="otherAddressType"
//                 value={address.otherAddressType || ""}
//                 onChange={handleChange}
//                 required
//                 className="w-full px-4 py-3 border-2 rounded-md bg-tertiary text-primary1 text-xs font-poppins focus:outline-none focus:ring-2 focus:ring-primary1 focus:border-tertiary"
//                 placeholder="Specify Address Type"
//               />
//             </div>
//           )}

//           {/* Address Fields */}
//           {[
//             { label: "House Number", name: "main_street", type: "text" },
//             { label: "Landmark", name: "landmark", type: "text" },
//             { label: "City", name: "city", type: "text" },
//             { label: "State", name: "state", type: "text" },
//             { label: "Postal Code", name: "postal_code", type: "text" },
//             { label: "Country", name: "country", type: "text" },
//           ].map((field, index) => (
//             <div key={index} className="-my-1">
//               <input
//                 id={field.name}
//                 name={field.name}
//                 type={field.type}
//                 value={address[field.name] || ""}
//                 onChange={handleChange}
//                 required
//                 className="w-full px-4 py-3 border-2 rounded-md bg-tertiary text-primary1 text-xs font-poppins focus:outline-none focus:ring-2 focus:ring-primary1 focus:border-tertiary"
//                 placeholder={field.label}
//               />
//             </div>
//           ))}

//           {/* Submit Button */}
//           <div className="lg:col-span-2 lg:flex justify-center gap-4 -mt-2">
//             <button type="submit" className="w-full py-2 bg-hcolor text-tertiary hover:border-2 hover:text-hcolor hover:bg-tertiary transition">
//               Add Address
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default AddressPopup;


import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { addNewAddress } from "../../Providers/addressProvider";

const AddressPopup = ({ onClose }) => {
  const dispatch = useDispatch();

  const [address, setAddress] = useState({
    user_id: localStorage.getItem("user_id") || "",
    first_name: "",
    last_name: "",
    mobile_number: "",
    email_id: "",
    addressType: "Home",
    main_street: "",
    city: "",
    state: "",
    postal_code: "",
    country: "",
    landmark: "",
    isDefault: false,
  });

  const [errors, setErrors] = useState({});

  const validateField = (name, value) => {
    let error = "";

    switch (name) {
      case "first_name":
      case "last_name":
        if (!/^[A-Za-z]*$/.test(value)) {
          error = "Only alphabets are allowed";
          return error; // Prevent updating state
        }
        break;

      case "mobile_number":
        if (!/^\d{0,10}$/.test(value)) {
          error = "Enter a valid 10-digit phone number";
          return error;
        }
        break;

      case "email_id":
        if (!/^[^\s@]*@[^\s@]*\.[^\s@]*$/.test(value) && value !== "") {
          error = "Enter a valid email address";
          return error;
        }
        break;

      case "postal_code":
        if (!/^\d{0,6}$/.test(value)) {
          error = "Enter a valid postal code";
          return error;
        }
        break;

      default:
        break;
    }

    return error; // Return empty string if valid
};

const handleChange = (e) => {
    const { name, value } = e.target;
    const error = validateField(name, value);

    setErrors((prevErrors) => ({ ...prevErrors, [name]: error }));

    if (!error) { // Update state only if there's no error
        setAddress((prevAddress) => ({ ...prevAddress, [name]: value }));
    }
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (Object.values(errors).some((err) => err)) return;

    try {
      const resultAction = await dispatch(addNewAddress(address));

      if (addNewAddress.fulfilled.match(resultAction)) {
        console.log("Address added successfully:", resultAction.payload);
      } else {
        console.error("Failed to add address:", resultAction.payload);
      }

      onClose();
    } catch (error) {
      console.error("Error adding address:", error);
    }
  };

  const cities = ["New York", "Los Angeles", "Chicago", "Houston", "Miami"];
  const states = ["California", "Texas", "Florida", "New York", "Illinois"];

  return (
    <div className="fixed inset-0 flex items-center justify-center z-30 overflow-y-scroll backdrop-blur-sm">
      <div className="bg-tertiary p-11 md:p-6 rounded md:w-[60%] relative top-24 lg:top-7">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-center w-full">Add New Address</h2>
          <FaTimes onClick={onClose} className="text-xl cursor-pointer" />
        </div>
        <hr className="mb-4" />
        <form onSubmit={handleSubmit} className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {[
            { label: "First Name", name: "first_name", type: "text" },
            { label: "Last Name", name: "last_name", type: "text" },
            { label: "Email", name: "email_id", type: "email" },
            { label: "Phone", name: "mobile_number", type: "tel" },
          ].map((field, index) => (
            <div key={index} className="-my-1">
              <input
                id={field.name}
                name={field.name}
                type={field.type}
                value={address[field.name] || ""}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border-2 rounded-md bg-tertiary text-primary1 text-xs font-poppins focus:outline-none focus:ring-2 focus:ring-primary1 focus:border-tertiary"
                placeholder={field.label}
              />
              {errors[field.name] && <p className="text-red-500 text-xs mt-1">{errors[field.name]}</p>}
            </div>
          ))}

          <div className="lg:col-span-1 gap-4">
            <div className="-my-1 relative">
              <select
                id="addressType"
                name="addressType"
                value={address.addressType}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border-2 rounded-md bg-tertiary text-primary1 text-xs font-poppins focus:outline-none focus:ring-2 focus:ring-primary1 focus:border-tertiary appearance-none"
              >
                <option value="Home">Home</option>
                <option value="Work">Work</option>
                <option value="Other">Other</option>
              </select>
            </div>
          </div>

          {address.addressType === "Other" && (
            <div className="-my-1 mb-4 relative">
              <input
                type="text"
                name="otherAddressType"
                value={address.otherAddressType || ""}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border-2 rounded-md bg-tertiary text-primary1 text-xs font-poppins focus:outline-none focus:ring-2 focus:ring-primary1 focus:border-tertiary"
                placeholder="Specify Address Type"
              />
            </div>
          )}

          {[
            { label: "House Number", name: "main_street", type: "text" },
            { label: "Landmark", name: "landmark", type: "text" },
          ].map((field, index) => (
            <div key={index} className="-my-1">
              <input
                id={field.name}
                name={field.name}
                type={field.type}
                value={address[field.name] || ""}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border-2 rounded-md bg-tertiary text-primary1 text-xs font-poppins focus:outline-none focus:ring-2 focus:ring-primary1 focus:border-tertiary"
                placeholder={field.label}
              />
            </div>
          ))}

          <div className="-my-1">
            <select
              id="city"
              name="city"
              value={address.city}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 border-2 rounded-md bg-tertiary text-primary1 text-xs font-poppins focus:outline-none focus:ring-2 focus:ring-primary1 focus:border-tertiary appearance-none"
            >
              <option value="">Select City</option>
              {cities.map((city) => (
                <option key={city} value={city}>
                  {city}
                </option>
              ))}
            </select>
          </div>

          <div className="-my-1">
            <select
              id="state"
              name="state"
              value={address.state}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 border-2 rounded-md bg-tertiary text-primary1 text-xs font-poppins focus:outline-none focus:ring-2 focus:ring-primary1 focus:border-tertiary appearance-none"
            >
              <option value="">Select State</option>
              {states.map((state) => (
                <option key={state} value={state}>
                  {state}
                </option>
              ))}
            </select>
          </div>

          <div className="-my-1">
            <input
              id="postal_code"
              name="postal_code"
              type="text"
              value={address.postal_code}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 border-2 rounded-md bg-tertiary text-primary1 text-xs font-poppins focus:outline-none focus:ring-2 focus:ring-primary1 focus:border-tertiary"
              placeholder="Postal Code"
            />
            {errors.postal_code && <p className="text-red-500 text-xs mt-1">{errors.postal_code}</p>}
          </div>

          <div className="lg:col-span-2">
  <button
    type="submit"
    className="w-full py-2 bg-hcolor text-tertiary hover:border-2 hover:text-hcolor hover:bg-tertiary transition"
  >
    Add Address
  </button>
</div>

        </form>
      </div>
    </div>
  );
};

export default AddressPopup;
